import React from 'react'
import CoveredSection from 'pages/HomePage/Components/CoveredSection/CoveredSection'
import FaqSection from 'components/FaqSection/FaqSection'
import FooterSection from 'components/FooterSection/FooterSection'
import FullScreenVideoSection from 'pages/HomePage/Components/FullScreenVideoSection/FullScreenVideoSection'
import SecondaryVideoSection from 'pages/HomePage/Components/SecondaryVideoSection/SecondaryVideoSection'
import SecondaryVideoGallery from 'pages/HomePage/Components/SecondaryVideoSection/SecondaryVideoGallery'
import TitleSection from './TitleSection/TitleSection'
import { ART_FAQS } from 'components/FaqSection/consts'
import {
  Main,
  WidthCapList,
  EndingContainer,
} from 'pages/HomePage/HomePageUI.styles'
import * as S from './ArtCollectionHomeUI.styles'
import useScreenSize from 'hooks/useScreenSize'
import {
  artHomepageDesktopVideos,
  artHomepageMobileVideos,
} from '../../HomePage/Components/SecondaryVideoSection/SecondaryVideoSection.consts'
import { useTranslation } from 'react-i18next'
import CategoryProductSection from './CategoryProductSection/CategoryProductSection'
import { useLanguage } from 'services/LangProvider'
import { LANGUAGES } from 'locale/Translation.consts'
import categoryNameToProductSection from './CategoryProductSection/CategoryProductSection.consts'

type Props = {
  artworkUrls: string[]
  categoryName: string | null
}

export default function ArtCollectionHomeUI({
  artworkUrls,
  categoryName,
}: Props) {
  const isMediumScreen = useScreenSize('md')
  const { t } = useTranslation()
  const language = useLanguage()

  const getCategoryProductSection = () => {
    const productSection =
      language === LANGUAGES.ENGLISH && categoryName
        ? categoryNameToProductSection[categoryName]
        : null

    return (
      productSection && (
        <WidthCapList>
          <S.Divider />
          <CategoryProductSection
            title={productSection.title}
            description={productSection.description}
          />
        </WidthCapList>
      )
    )
  }

  return (
    <Main>
      <WidthCapList $fullscreen>
        <TitleSection artworkUrls={artworkUrls} categoryName={categoryName} />
        {isMediumScreen ? (
          <SecondaryVideoGallery videos={artHomepageDesktopVideos} />
        ) : (
          <SecondaryVideoSection videos={artHomepageMobileVideos} />
        )}
        <FullScreenVideoSection
          cldId={
            isMediumScreen
              ? 'assets/art/homepage/videos/quality-desktop'
              : 'assets/art/homepage/videos/quality'
          }
          folder="art/homepage"
          videoText={t('homepage.fullscreen_title_desktop')}
        />
      </WidthCapList>

      <EndingContainer>
        <WidthCapList>
          <S.CoveredContainer>
            <CoveredSection />
          </S.CoveredContainer>
          <FaqSection faqs={ART_FAQS} source="Art" />
        </WidthCapList>
        {getCategoryProductSection()}
      </EndingContainer>

      <S.FooterContainer>
        <WidthCapList>
          <FooterSection />
        </WidthCapList>
      </S.FooterContainer>
    </Main>
  )
}
